export default "__VITE_ASSET__CjRkFPLA__"